import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import Table from '../Table';
import { FormattedMessage, useIntl } from 'react-intl';
import { Box, Button, ButtonGroup, HStack, Stack, Th, Tr } from '@chakra-ui/react';
import SongRow from './SongRow';
import EmptyState from '../EmptyState';
import TableHeading from '../TableHeading';
import { PlaylistSortType } from '@/types/client';
import Pagination from '../Pagination';
import SearchInput from '../SearchInput';
function PlaylistTable(param) {
    var playlist = param.playlist, total = param.total, page = param.page, limit = param.limit, sortType = param.sortType, sortDirection = param.sortDirection, isSearching = param.isSearching, search = param.search, onSearch = param.onSearch, setSort = param.setSort, onAddPlaylistItem = param.onAddPlaylistItem, onLimit = param.onLimit, onNextPage = param.onNextPage, onPreviousPage = param.onPreviousPage, onDeletePlaylistItem = param.onDeletePlaylistItem, beforeControlsElement = param.beforeControlsElement, afterControlsElement = param.afterControlsElement;
    var intl = useIntl();
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsxs(Stack, {
            gap: 6,
            flex: 1,
            children: [
                /*#__PURE__*/ _jsxs(HStack, {
                    justifyContent: "space-between",
                    display: {
                        base: 'none',
                        sm: 'flex'
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(ButtonGroup, {
                            spacing: 6,
                            size: "sm",
                            variant: "outline",
                            children: [
                                beforeControlsElement,
                                /*#__PURE__*/ _jsx(SearchInput, {
                                    placeholder: intl.formatMessage({
                                        id: "tvzbUc",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Search playlist..."
                                            }
                                        ]
                                    }),
                                    setSearch: onSearch,
                                    search: search,
                                    isSearching: isSearching
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(ButtonGroup, {
                            spacing: 6,
                            size: "sm",
                            variant: "outline",
                            children: [
                                onAddPlaylistItem != null ? /*#__PURE__*/ _jsx(Button, {
                                    marginLeft: "auto",
                                    variant: "cta",
                                    onClick: onAddPlaylistItem,
                                    display: {
                                        base: 'none',
                                        md: 'block'
                                    },
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "Fgv+B2",
                                        defaultMessage: "Add Song"
                                    })
                                }) : null,
                                afterControlsElement
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Box, {
                    display: {
                        base: 'flex',
                        sm: 'none'
                    },
                    children: beforeControlsElement
                }),
                /*#__PURE__*/ _jsxs(ButtonGroup, {
                    gap: 4,
                    size: "sm",
                    display: {
                        base: 'flex',
                        sm: 'none'
                    },
                    children: [
                        /*#__PURE__*/ _jsx(SearchInput, {
                            placeholder: intl.formatMessage({
                                id: "tvzbUc",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "Search playlist..."
                                    }
                                ]
                            }),
                            setSearch: onSearch,
                            search: search,
                            isSearching: isSearching
                        }),
                        afterControlsElement
                    ]
                }),
                /*#__PURE__*/ _jsx(Table, {
                    flex: 1,
                    data: playlist,
                    extraData: [
                        onDeletePlaylistItem,
                        sortType,
                        sortDirection,
                        page,
                        limit,
                        total,
                        onLimit,
                        onNextPage,
                        onPreviousPage,
                        setSort
                    ],
                    renderHeader: function() {
                        return /*#__PURE__*/ _jsxs(Tr, {
                            children: [
                                /*#__PURE__*/ _jsx(TableHeading, {
                                    active: sortType === PlaylistSortType.TITLE,
                                    sort: sortType === PlaylistSortType.TITLE ? sortDirection : undefined,
                                    setSort: function(direction) {
                                        return setSort(PlaylistSortType.TITLE, direction);
                                    },
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "6lp/1f",
                                        defaultMessage: "Song"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(TableHeading, {
                                    width: "1px",
                                    display: {
                                        base: 'none',
                                        md: 'table-cell'
                                    },
                                    active: sortType === PlaylistSortType.CREATED_AT,
                                    sort: sortType === PlaylistSortType.CREATED_AT ? sortDirection : undefined,
                                    setSort: function(direction) {
                                        return setSort(PlaylistSortType.CREATED_AT, direction);
                                    },
                                    children: /*#__PURE__*/ _jsx(FormattedMessage, {
                                        id: "wNCvfg",
                                        defaultMessage: "Added On"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Th, {})
                            ]
                        });
                    },
                    renderRow: function(song) {
                        return /*#__PURE__*/ _jsx(SongRow, {
                            song: song,
                            showRequester: false,
                            onDelete: onDeletePlaylistItem
                        });
                    },
                    renderEmptyState: function() {
                        return /*#__PURE__*/ _jsx(EmptyState, {
                            flex: 1,
                            title: intl.formatMessage({
                                id: "QaDpK4",
                                defaultMessage: [
                                    {
                                        type: 0,
                                        value: "No playlist items"
                                    }
                                ]
                            })
                        });
                    },
                    renderFooter: function() {
                        return /*#__PURE__*/ _jsx(Pagination, {
                            limit: limit,
                            page: page,
                            total: total,
                            setLimit: onLimit,
                            nextPage: onNextPage,
                            previousPage: onPreviousPage
                        });
                    }
                })
            ]
        })
    });
}
export default PlaylistTable;
